var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{attrs:{"id":""},domProps:{"innerHTML":_vm._s(_vm.tableau)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }